module.exports = __webpack_public_path__ + "static/media/calculate.d337f965.yaml";